import { Checkbox } from "../ui/checkbox";
import styles from "./input.module.scss";

type InputRadioProps = {
  name: string;
  value: boolean;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const InputRadio: React.FC<InputRadioProps> = ({
  name,
  value,
  label,
  onChange,
}) => {
  // Generate unique ID from name for label association
  const checkboxId = `contact-${name}`;

  const handleCheckedChange = (e: { checked: boolean }) => {
    // Create a synthetic event that matches the expected onChange signature
    const syntheticEvent = {
      target: {
        name,
        value: e.checked,
        checked: e.checked,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(syntheticEvent);
  };

  return (
    <div className={styles.radioContainer}>
      <label className={styles.inputLabel} htmlFor={checkboxId}>
        <Checkbox
          name={name}
          checked={value}
          onCheckedChange={handleCheckedChange}
          required
          id={checkboxId}
          className={styles.radio}
        >
          {label}
        </Checkbox>
      </label>
    </div>
  );
};

export default InputRadio;
